// bao migrate skip
import TabPage from "./../../factories/tab-page";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-searcher";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
class ConfigurationItem210SoftwareTab extends GenericListSearchTab {
    SearchType(): string {
        return "Software";
    }
    ConfigurationItemId: any;
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.ConfigurationItemId = parent;
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
}
export default ConfigurationItem210SoftwareTab;